module.exports = __webpack_public_path__ + "static/media/blog.cafbe6c2.png";